const AppHeaderStyle = {
  borderHeight: 5,
  containerHeight: 60,
};

export default AppHeaderStyle;
